// ฟังก์ชันสำหรับอัพเดทข้อมูลโดยตรงในฐานข้อมูล
// ใช้สำหรับแก้ไขข้อมูลที่ไม่ตรงกับหน้า profile

import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

/**
 * อัพเดทข้อมูลเอ๊ะ ดีแต่ปากให้ตรงกับหน้า profile
 * @returns {Promise<boolean>}
 */
export const updateAeDataToMatchProfile = async () => {
  try {
    console.log('🔧 เริ่มอัพเดทข้อมูลเอ๊ะ ดีแต่ปากให้ตรงกับหน้า profile...');
    
    const girlsRef = collection(db, 'girls');
    const snapshot = await getDocs(girlsRef);
    
    let found = false;
    
    for (const docSnapshot of snapshot.docs) {
      const data = docSnapshot.data();
      
      if (data.nickname === 'เอ๊ะ ดีแต่ปาก') {
        console.log('👧 พบข้อมูลเอ๊ะ ดีแต่ปาก:', data);
        
        // อัพเดทข้อมูลให้ตรงกับหน้า profile
        await updateDoc(docSnapshot.ref, {
          subscription: 'premium',
          description: 'เล่นได้ ดื่มเก่ง',
          bio: 'เล่นได้ ดื่มเก่ง',
          type: 'vn',
          grades: 4,
          momoName: 'มอมจอย',
          updatedAt: new Date()
        });
        
        console.log('✅ อัพเดทข้อมูลเอ๊ะ ดีแต่ปากสำเร็จ!');
        console.log('📋 ข้อมูลใหม่:');
        console.log('  - subscription: premium');
        console.log('  - description: เล่นได้ ดื่มเก่ง');
        console.log('  - bio: เล่นได้ ดื่มเก่ง');
        console.log('  - type: vn');
        console.log('  - grades: 4');
        console.log('  - momoName: มอมจอย');
        
        found = true;
        break;
      }
    }
    
    if (!found) {
      console.log('❌ ไม่พบข้อมูลเอ๊ะ ดีแต่ปากในฐานข้อมูล');
      return false;
    }
    
    return true;
    
  } catch (error) {
    console.error('❌ เกิดข้อผิดพลาดในการอัพเดทข้อมูล:', error);
    return false;
  }
};

/**
 * อัพเดทข้อมูลทั้งหมดให้ตรงกับหน้า profile
 * @returns {Promise<boolean>}
 */
export const updateAllGirlsDataToMatchProfile = async () => {
  try {
    console.log('🔧 เริ่มอัพเดทข้อมูลทั้งหมดให้ตรงกับหน้า profile...');
    
    const girlsRef = collection(db, 'girls');
    const snapshot = await getDocs(girlsRef);
    
    const promises = snapshot.docs.map(async (docSnapshot) => {
      const data = docSnapshot.data();
      let updateData = {};
      
      if (data.nickname === 'เอ๊ะ ดีแต่ปาก') {
        updateData = {
          subscription: 'premium',
          description: 'เล่นได้ ดื่มเก่ง',
          bio: 'เล่นได้ ดื่มเก่ง',
          type: 'vn',
          grades: 4,
          momoName: 'มอมจอย'
        };
      } else if (data.nickname === 'ฝ้าย น่างับ') {
        updateData = {
          subscription: 'premium',
          description: 'สาวน่ารัก หน้าตาดี บริการดีมาก มีประสบการณ์',
          bio: 'สาวน่ารัก หน้าตาดี',
          type: 'vn',
          grades: 4.8,
          momoName: 'มอมแอม'
        };
      } else if (data.nickname === 'น้องใหม่') {
        updateData = {
          subscription: 'vip',
          description: 'สาวแกร่ง ใจดี มีความมั่นใจสูง บริการดีเยี่ยม',
          bio: 'สาวแกร่ง ใจดี',
          type: 'strong',
          grades: 4.2,
          momoName: 'มอมซี'
        };
      }
      
      if (Object.keys(updateData).length > 0) {
        await updateDoc(docSnapshot.ref, {
          ...updateData,
          updatedAt: new Date()
        });
        console.log(`✅ อัพเดทข้อมูล ${data.nickname} สำเร็จ`);
      }
    });
    
    await Promise.all(promises);
    console.log('✅ อัพเดทข้อมูลทั้งหมดสำเร็จ!');
    return true;
    
  } catch (error) {
    console.error('❌ เกิดข้อผิดพลาดในการอัพเดทข้อมูลทั้งหมด:', error);
    return false;
  }
};









